// Mirrors the Prisma enums of the same name (backend/prisma/schema/settings.prisma).
// Defined as const-object + literal-union so values are assignable from both the
// Prisma client enums and the generated frontend api types without casts.
export const NameRepresentation = {
  firstNameBeforeLastName: 'firstNameBeforeLastName',
  lastNameBeforeFirstName: 'lastNameBeforeFirstName',
} as const;
export type NameRepresentation = (typeof NameRepresentation)[keyof typeof NameRepresentation];

export const NameSortation = {
  sortByFirstName: 'sortByFirstName',
  sortByLastName: 'sortByLastName',
} as const;
export type NameSortation = (typeof NameSortation)[keyof typeof NameSortation];

export const WeekRepresentation = {
  calendarWeek: 'calendarWeek',
  schoolWeek: 'schoolWeek',
} as const;
export type WeekRepresentation = (typeof WeekRepresentation)[keyof typeof WeekRepresentation];
